<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="748.974"
    height="457.275"
    viewBox="0 0 748.974 457.275"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    role="img"
    artist="Katerina Limpitsouni"
    source="https://undraw.co/"
  >
    <g
      id="Group_201"
      data-name="Group 201"
      transform="translate(-382.003 -195.455)"
    >
      <g
        id="Group_200"
        data-name="Group 200"
        transform="translate(382.003 195.455)"
      >
        <path
          id="Path_3120-420"
          data-name="Path 3120"
          d="M695.225,508.82,433.394,576.244a34.622,34.622,0,0,1-42.114-24.866L312.1,243.879a34.622,34.622,0,0,1,24.866-42.114l243.591-62.727L642.9,166.948l77.191,299.757A34.622,34.622,0,0,1,695.225,508.82Z"
          transform="translate(-311.003 -139.037)"
          fill="#f2f2f2"
        />
        <path
          id="Path_3121-421"
          data-name="Path 3121"
          d="M338.989,210.925a24.655,24.655,0,0,0-17.708,29.99l79.185,307.5a24.655,24.655,0,0,0,29.99,17.708L692.287,498.7a24.655,24.655,0,0,0,17.708-29.99L634,173.595l-54.792-24.529Z"
          transform="translate(-310.548 -138.556)"
          fill="#fff"
        />
        <path
          id="Path_3122-422"
          data-name="Path 3122"
          d="M629.927,168.5l-40.522,10.435a11.518,11.518,0,0,1-14.026-8.282l-7.707-29.929a.72.72,0,0,1,.989-.837l61.379,27.258a.72.72,0,0,1-.113,1.355Z"
          transform="translate(-298.695 -139)"
          fill="#f2f2f2"
        />
        <path
          id="Path_3123-423"
          data-name="Path 3123"
          d="M612.519,418.284l-119.208,30.7a5.759,5.759,0,0,1-2.872-11.154l119.208-30.7a5.759,5.759,0,1,1,2.872,11.154Z"
          transform="translate(-302.605 -126.189)"
          fill="#ccc"
        />
        <path
          id="Path_3124-424"
          data-name="Path 3124"
          d="M640.149,430.592,497.936,467.214a5.759,5.759,0,1,1-2.872-11.154l142.213-36.622a5.759,5.759,0,0,1,2.872,11.154Z"
          transform="translate(-302.384 -125.599)"
          fill="#ccc"
        />
        <circle
          id="Ellipse_44"
          data-name="Ellipse 44"
          cx="20.355"
          cy="20.355"
          r="20.355"
          transform="translate(121.697 319.055)"
          fill="#f59e0b"
        />
        <path
          id="Path_3125-425"
          data-name="Path 3125"
          d="M604.421,374.437,446.1,415.191a17.835,17.835,0,0,1-21.694-12.812L391.229,273.49A17.835,17.835,0,0,1,404.041,251.8l158.32-40.754a17.835,17.835,0,0,1,21.694,12.812l33.178,128.889A17.835,17.835,0,0,1,604.421,374.437Z"
          transform="translate(-307.183 -135.611)"
          fill="#fff"
        />
        <path
          id="Path_3126-426"
          data-name="Path 3126"
          d="M604.421,374.437,446.1,415.191a17.835,17.835,0,0,1-21.694-12.812L391.229,273.49A17.835,17.835,0,0,1,404.041,251.8l158.32-40.754a17.835,17.835,0,0,1,21.694,12.812l33.178,128.889A17.835,17.835,0,0,1,604.421,374.437ZM404.563,253.826a15.737,15.737,0,0,0-11.3,19.142l33.178,128.889a15.737,15.737,0,0,0,19.142,11.3L603.9,372.407a15.737,15.737,0,0,0,11.3-19.142L582.025,224.376a15.737,15.737,0,0,0-19.142-11.3Z"
          transform="translate(-307.183 -135.611)"
          fill="#e6e6e6"
        />
        <path
          id="Path_411-427"
          data-name="Path 411"
          d="M550.66,252.63l-79.9,20.568a2.862,2.862,0,0,1-3.467-1.8,2.757,2.757,0,0,1,1.942-3.5l81.335-20.937c3.286,1.665,2.421,5.07.091,5.67Z"
          transform="translate(-303.514 -133.861)"
          fill="#f2f2f2"
        />
        <path
          id="Path_412-428"
          data-name="Path 412"
          d="M554.1,266l-79.9,20.568a2.862,2.862,0,0,1-3.467-1.8,2.757,2.757,0,0,1,1.942-3.5l81.335-20.937c3.286,1.665,2.421,5.07.091,5.67Z"
          transform="translate(-303.349 -133.22)"
          fill="#f2f2f2"
        />
        <path
          id="Path_413-429"
          data-name="Path 413"
          d="M461.146,298.825,436.761,305.1a3.1,3.1,0,0,1-3.776-2.23L425.577,274.1a3.1,3.1,0,0,1,2.23-3.776l24.385-6.277a3.105,3.105,0,0,1,3.776,2.23l7.408,28.777a3.1,3.1,0,0,1-2.23,3.776Z"
          transform="translate(-305.513 -133.047)"
          fill="#f59e0b"
        />
        <path
          id="Path_414-430"
          data-name="Path 414"
          d="M562.854,293.445,440.909,324.835a2.862,2.862,0,0,1-3.467-1.8,2.757,2.757,0,0,1,1.942-3.5l123.38-31.76c3.286,1.665,2.421,5.07.091,5.67Z"
          transform="translate(-304.946 -131.904)"
          fill="#f2f2f2"
        />
        <path
          id="Path_415-431"
          data-name="Path 415"
          d="M566.3,306.822,444.353,338.213a2.862,2.862,0,0,1-3.467-1.8,2.757,2.757,0,0,1,1.942-3.5l123.38-31.76c3.286,1.665,2.421,5.07.091,5.67Z"
          transform="translate(-304.781 -131.263)"
          fill="#f2f2f2"
        />
        <path
          id="Path_416-432"
          data-name="Path 416"
          d="M569.739,320.192,447.794,351.582a2.862,2.862,0,0,1-3.467-1.8,2.757,2.757,0,0,1,1.942-3.5l123.379-31.76c3.286,1.665,2.421,5.07.091,5.67Z"
          transform="translate(-304.616 -130.621)"
          fill="#f2f2f2"
        />
        <path
          id="Path_417-433"
          data-name="Path 417"
          d="M573.183,333.569,451.237,364.959a2.862,2.862,0,0,1-3.467-1.8,2.757,2.757,0,0,1,1.942-3.5l123.38-31.76C576.377,329.564,575.513,332.969,573.183,333.569Z"
          transform="translate(-304.45 -129.98)"
          fill="#f2f2f2"
        />
        <path
          id="Path_418-434"
          data-name="Path 418"
          d="M576.624,346.939,454.679,378.329a2.862,2.862,0,0,1-3.467-1.8,2.757,2.757,0,0,1,1.942-3.5l123.38-31.76C579.819,342.934,578.954,346.339,576.624,346.939Z"
          transform="translate(-304.285 -129.339)"
          fill="#f2f2f2"
        />
        <path
          id="Path_395-435"
          data-name="Path 395"
          d="M448.363,470.511a2.111,2.111,0,0,1-1.335-.092l-.026-.011-5.545-2.351a2.126,2.126,0,1,1,1.664-3.913l3.593,1.528,4.708-11.076a2.125,2.125,0,0,1,2.787-1.124h0l-.028.072.029-.073a2.127,2.127,0,0,1,1.124,2.788l-5.539,13.023a2.126,2.126,0,0,1-1.431,1.224Z"
          transform="translate(-304.809 -123.966)"
          fill="#fff"
        />
      </g>
      <g
        id="Group_199"
        data-name="Group 199"
        transform="translate(673.007 225.872) rotate(-8)"
      >
        <g
          id="Group_198"
          data-name="Group 198"
          transform="translate(125.896 0) rotate(19)"
        >
          <path
            id="Path_3127-436"
            data-name="Path 3127"
            d="M304.956,386.7H34.583A34.622,34.622,0,0,1,0,352.114V34.583A34.622,34.622,0,0,1,34.583,0H286.121l53.418,42.577V352.114A34.622,34.622,0,0,1,304.956,386.7Z"
            transform="translate(0 0)"
            fill="#e6e6e6"
          />
          <path
            id="Path_3128-437"
            data-name="Path 3128"
            d="M24.627,0A24.655,24.655,0,0,0,0,24.627V342.158a24.655,24.655,0,0,0,24.627,24.627H295a24.655,24.655,0,0,0,24.627-24.627V37.418L272.683,0Z"
            transform="translate(9.956 9.956)"
            fill="#fff"
          />
          <path
            id="Path_3129-438"
            data-name="Path 3129"
            d="M128.856,11.518H5.759A5.759,5.759,0,0,1,5.759,0h123.1a5.759,5.759,0,0,1,0,11.518Z"
            transform="translate(123.512 90.767)"
            fill="#f59e0b"
          />
          <path
            id="Path_3130-439"
            data-name="Path 3130"
            d="M152.612,11.518H5.759A5.759,5.759,0,0,1,5.759,0H152.612a5.759,5.759,0,1,1,0,11.518Z"
            transform="translate(123.512 110.204)"
            fill="#f59e0b"
          />
          <path
            id="Path_3131-440"
            data-name="Path 3131"
            d="M128.852,0H5.758a5.758,5.758,0,1,0,0,11.517H128.852a5.759,5.759,0,0,0,0-11.517Z"
            transform="translate(123.517 177.868)"
            fill="#ccc"
          />
          <path
            id="Path_3132-441"
            data-name="Path 3132"
            d="M152.609,0H5.758a5.759,5.759,0,1,0,0,11.517h146.85a5.759,5.759,0,1,0,0-11.517Z"
            transform="translate(123.517 197.307)"
            fill="#ccc"
          />
          <path
            id="Path_3133-442"
            data-name="Path 3133"
            d="M128.856,11.518H5.759A5.759,5.759,0,0,1,5.759,0h123.1a5.759,5.759,0,0,1,0,11.518Z"
            transform="translate(123.512 264.975)"
            fill="#ccc"
          />
          <path
            id="Path_3134-443"
            data-name="Path 3134"
            d="M152.612,11.518H5.759A5.759,5.759,0,0,1,5.759,0H152.612a5.759,5.759,0,1,1,0,11.518Z"
            transform="translate(123.512 284.411)"
            fill="#ccc"
          />
          <circle
            id="Ellipse_44-2"
            data-name="Ellipse 44"
            cx="20.355"
            cy="20.355"
            r="20.355"
            transform="translate(57.655 85.89)"
            fill="#f59e0b"
          />
          <path
            id="Path_395-2-444"
            data-name="Path 395"
            d="M6.909,15.481a2.111,2.111,0,0,1-1.27-.422l-.023-.017L.832,11.382A2.126,2.126,0,0,1,3.419,8.008l3.1,2.376L13.839.832A2.125,2.125,0,0,1,16.819.439h0L16.774.5l.047-.063a2.127,2.127,0,0,1,.393,2.98L8.6,14.649a2.126,2.126,0,0,1-1.691.829Z"
            transform="translate(69.085 98.528)"
            fill="#fff"
          />
          <path
            id="Path_3135-445"
            data-name="Path 3135"
            d="M40.707,20.359A20.354,20.354,0,0,1,20.356,40.721a4.372,4.372,0,0,1-.524-.021A20.353,20.353,0,1,1,40.707,20.359Z"
            transform="translate(59.75 172.987)"
            fill="#f59e0b"
          />
          <circle
            id="Ellipse_44-3"
            data-name="Ellipse 44"
            cx="20.355"
            cy="20.355"
            r="20.355"
            transform="translate(57.655 260.097)"
            fill="#f59e0b"
          />
          <path
            id="Path_3136-446"
            data-name="Path 3136"
            d="M53.362,43.143H11.518A11.518,11.518,0,0,1,0,31.625V.72A.72.72,0,0,1,1.167.156l52.642,41.7a.72.72,0,0,1-.447,1.284Z"
            transform="translate(285.137 0.805)"
            fill="#ccc"
          />
        </g>
      </g>
      <path
        id="Path_3140-447"
        data-name="Path 3140"
        d="M754.518,518.049a9.158,9.158,0,0,1-12.587,3.05L635.078,455.923a9.158,9.158,0,0,1,9.538-15.637l106.852,65.176a9.158,9.158,0,0,1,3.049,12.587Z"
        transform="translate(123.58 101.359)"
        fill="#3f3d56"
      />
      <path
        id="Path_3141-448"
        data-name="Path 3141"
        d="M688.648,486.5a73.265,73.265,0,1,1-24.4-100.7A73.265,73.265,0,0,1,688.648,486.5ZM579.19,419.73a54.949,54.949,0,1,0,75.524-18.3,54.949,54.949,0,0,0-75.524,18.3Z"
        transform="translate(82.597 67.737)"
        fill="#3f3d56"
      />
      <circle
        id="Ellipse_44-4"
        data-name="Ellipse 44"
        cx="57.007"
        cy="57.007"
        r="57.007"
        transform="translate(672.542 442.858) rotate(19)"
        fill="#f59e0b"
      />
    </g>
  </svg>
</template>
